import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const SpiritualServicesAgreementPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page" data-testid="spiritual-services-agreement-page">
      {/* Block this page from search engines */}
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>Spiritual Services Agreement - Amatya</title>
      </Helmet>
      
      <div className="legal-container">
        <h1 className="legal-title">Spiritual Services Agreement and User Consent</h1>

        <section className="legal-section">
          <h2>1. Introduction</h2>
          <p>
            This Spiritual Services Agreement governs the use of astrology, puja, chadhava, and spiritual advisory services offered through www.amatya.co.in under the brand AMATYA, operated by ANS Legal and Business Services LLP, having its office at C-209, M3M Urbana, Sector 67, Gurgaon, 122101 Haryana. By accessing or using our services, you agree to the terms outlined in this agreement.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Nature of Services</h2>
          <p>
            The services offered on this platform include astrology consultations, spiritual guidance, puja facilitation, religious rituals, and related offerings based on traditional Hindu scriptures, beliefs, and practices.
          </p>
        </section>

        <section className="legal-section">
          <h2>3. Faith-Based Services</h2>
          <p>
            All services offered through the platform are based on traditional belief systems and spiritual practices. These services are matters of faith and interpretation and should be treated as spiritual guidance rather than guaranteed outcomes.
          </p>
        </section>

        <section className="legal-section">
          <h2>4. No Guaranteed Results</h2>
          <p>
            Users acknowledge and agree that astrology readings, pujas, rituals, and spiritual consultations are interpretative in nature. No guarantees are made regarding outcomes, success, or results from any service booked through this platform.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. User Responsibility</h2>
          <p>
            Any decisions taken by users based on consultations, spiritual advice, or astrological interpretation are solely their responsibility. The platform and its representatives shall not be held liable for personal, financial, emotional, or professional decisions taken by users.
          </p>
        </section>

        <section className="legal-section">
          <h2>6. Priest and Ritual Services</h2>
          <p>
            Puja or religious rituals may be performed by priests or temple representatives based on traditional procedures, availability, and religious customs. Exact timings, procedures, or locations may vary depending on temple practices.
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Refunds and Cancellations</h2>
          <p>
            Refunds and cancellations for puja services or astrology consultations shall be governed by the Refund Policy stated in the Terms of Use available on the website.
          </p>
        </section>

        <section className="legal-section">
          <h2>8. Limitation of Liability</h2>
          <p>
            Under no circumstances shall ANS Legal and Business Services LLP, its partners, employees, astrologers, priests, or representatives be liable for any direct, indirect, incidental, consequential, or special damages arising from the use of services offered through the platform.
          </p>
        </section>

        <section className="legal-section">
          <h2>9. Acceptance of Terms</h2>
          <p>
            By booking a service, making a payment, or using the platform, users confirm that they have read, understood, and agreed to this Spiritual Services Agreement along with the Terms of Use and Privacy Policy of www.amatya.co.in.
          </p>
        </section>

        <section className="legal-section">
          <h2>10. Contact Information</h2>
          <p>For any questions regarding this agreement please contact:</p>
          <div className="legal-contact">
            <p><strong>Mr. Sumitt Saini, CEO</strong></p>
            <p><strong>Email:</strong> care@amatya.co.in</p>
            <p><strong>Phone:</strong> +91 9711767167</p>
            <p><strong>Address:</strong> C-209, M3M Urbana, Sector 67, Gurgaon, 122101 Haryana</p>
          </div>
        </section>

        <section className="legal-section">
          <h2>11. Governing Law</h2>
          <p>
            This Agreement shall be governed by the laws of India and any disputes shall be subject to the exclusive jurisdiction of Courts of New Delhi, India.
          </p>
        </section>
      </div>
    </div>
  );
};

export default SpiritualServicesAgreementPage;
